function FieldGrid(_props) {
  const {
    columns = 4, //4 | 2 | 1
    children
  } = _props
  
  if ([4, 2, 1].indexOf(columns) === -1) {
    throw new Error('FieldGrid: columns must be 4, 2 or 1')
  }

  const colClasses = {
    "4": "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    "2": "grid-cols-1 md:grid-cols-2",
    "1": "grid-cols-1"
  }

  return (
    <div className={'grid  gap-x-4 gap-y-8 min-w-[30rem] w-full '+colClasses[`${columns}`]}>
      {children}
    </div>
  )
}

export default FieldGrid